import StoreModule from "@/utils/StoreModule";

const attendanceGetSetting = StoreModule("/hr/setting/get-setting/attendance");

export default attendanceGetSetting;
